import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'absenteeism',
    label: 'Absenteeism',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
